module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraLight.02e9b1f5.woff2";